import Vue from 'vue/dist/vue.esm.js'
import Vuex from 'vuex'
import cart from '@/store/modules/cart'
import checkout from '@/store/modules/checkout'
import debugConsole from '@/store/modules/debugConsole'
import filters from '@/store/modules/filters'
import products from '@/store/modules/products'
import buyGuide from '@/store/modules/buy-guide'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

const store = new Vuex.Store({
  modules: {
    cart,
    debugConsole,
    filters,
    products,
    checkout,
    buyGuide
  },
  strict: debug
})

// No global store exposure; keep store internal to app

export default store
